/* Trust badges block (snippets/nb-trust-badges.liquid): the FREE gifts popup.
   One delegated listener per page, so it keeps working when the theme re-renders the
   product info on a variant change. On open, the offer table is redrawn from the gift
   engine's tiers (window.NB_GIFT_RULES.tiersSpec, CUMULATIVE increments per threshold),
   so a tier change in the gift rules metaobject shows here too. Without the gift rules
   on the page the server-rendered default rows stay as they are. */
(function () {
  if (window.__nbTrustBadges) return;
  window.__nbTrustBadges = true;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function drawRows(tbody) {
    var rules = window.NB_GIFT_RULES;
    var spec = rules && Array.isArray(rules.tiersSpec) ? rules.tiersSpec : null;
    if (!spec || !spec.length) return;

    var ship = parseInt(tbody.dataset.ship, 10) || 0;
    var free = escapeHtml(tbody.dataset.free || '');
    var standard = escapeHtml(tbody.dataset.standard || '');
    var one = escapeHtml(tbody.dataset.bagOne || '');
    var many = escapeHtml(tbody.dataset.bagMany || '');

    var thresholds = spec.map(function (t) { return Number(t.threshold) || 0; }).filter(function (n) { return n > 0; });
    if (ship > 0) thresholds.push(ship);
    thresholds = thresholds.filter(function (n, i, all) { return all.indexOf(n) === i; }).sort(function (a, b) { return a - b; });

    var html = '';
    thresholds.forEach(function (n, i) {
      var clips = 0;
      var bags = 0;
      spec.forEach(function (t) {
        if ((Number(t.threshold) || 0) <= n) {
          clips += Number(t.carab) || 0;
          bags += Number(t.bag) || 0;
        }
      });
      var last = i === thresholds.length - 1;
      html += '<tr' + (last ? ' class="nb-trust-offer__best"' : '') + '>' +
        '<th scope="row">' + n + (last ? '+' : '') + ' ' + (n === 1 ? one : many) + '</th>' +
        '<td' + (clips ? '' : ' class="nb-trust-offer__empty"') + '>' + (clips || '–') + '</td>' +
        '<td' + (bags ? '' : ' class="nb-trust-offer__empty"') + '>' + (bags || '–') + '</td>' +
        (ship > 0
          ? (n >= ship ? '<td class="nb-trust-offer__free">' + free + '</td>' : '<td class="nb-trust-offer__empty">' + standard + '</td>')
          : '') +
        '</tr>';
    });
    tbody.innerHTML = html;
  }

  function open(trigger) {
    var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;

    var tbody = dialog.querySelector('[data-nb-trust-rows]');
    if (tbody) {
      try { drawRows(tbody); } catch (e) {}
    }

    if (!dialog.__nbTrustBound) {
      dialog.__nbTrustBound = true;
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('nb-trust-locked');
        if (dialog.__nbTrustTrigger && document.contains(dialog.__nbTrustTrigger)) dialog.__nbTrustTrigger.focus();
      });
      // A click on the backdrop lands on the <dialog> itself, outside its box
      dialog.addEventListener('click', function (e) {
        if (e.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
    }

    dialog.__nbTrustTrigger = trigger;
    dialog.showModal();
    document.documentElement.classList.add('nb-trust-locked');
    // NB12 tracking: the gift offer popup was opened (dataLayer only, see window.nbTrack in the layout)
    if (window.nbTrack) window.nbTrack({ event: 'nb_trust_gift_open', nb_arm: window.nbArm });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[data-nb-trust-open]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }
    var close = t.closest('[data-nb-trust-close]');
    if (close) {
      var dialog = close.closest('dialog');
      if (dialog) dialog.close();
    }
  });
})();
